<template>
  <div class="py-3 bg-transparent">
    <div class="notification-header mb-8">
      <div class="flex items-center justify-start gap-8">
        <span
          class="cursor-pointer notification__inactive"
          :class="{
            notification__active: notificationType === 'learning-actions',
          }"
          id="learning-actions"
          @click="notificationType = 'learning-actions'"
          v-if="appSubscriptions.alex"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Learning Actions</h4>
        </span>
        <span
          v-if="appSubscriptions.journey && galaQuests"
          class="cursor-pointer notification__inactive"
          :class="{
            notification__active: notificationType === 'journey-quests',
          }"
          id="journey-quests"
          @click="notificationType = 'journey-quests'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Journey Quests</h4>
        </span>
        <span
          v-if="appSubscriptions.coach"
          class="cursor-pointer notification__inactive"
          :class="{ notification__active: notificationType === 'growth-plans' }"
          id="growth-plans"
          @click="notificationType = 'growth-plans'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Growth Plans</h4>
        </span>
      </div>
    </div>

    <div class="notification__container w-full h-full mt-4">
      <div v-if="loadingSkeleton" class="">
        <vs-row class="px-3 py-3">
          <vs-row
            v-for="i in 5"
            :key="i"
            class="p-16 rounded-lg my-2 bg-slate-300 animate-pulse"
          />
        </vs-row>
      </div>

      <div v-if="!loadingSkeleton" class="rounded-lg overflow-hidden">
        <div
          v-if="
            notificationType === 'learning-actions' && appSubscriptions.alex
          "
        >
          <!-- validation notification -->
          <div
            v-if="items && items.length > 0 && !loadingSkeleton"
            class="flex flex-col gap-1"
          >
            <div
              v-for="(item, index) in items"
              :key="item.itemId"
              :id="item.itemId"
              style="display: flex"
              class="items-center justify-between w-full bg-white py-6 px-4"
              :class="{
                hidden: !(
                  (item.status === 'done' ||
                    item.feedLibraryItemStatus === 'done') &&
                  item.libraryItemValidationData
                ),
              }"
            >
              <div class="flex w-full gap-4">
                <div class="w-24 h-24 overflow-hidden rounded-lg">
                  <img
                    class="w-full h-full object-cover"
                    :src="item.imageUrl"
                    @error="randomFeedImage"
                  />
                </div>
                <div class="flex flex-col gap-4 w-full justify-between">
                  <div class="flex flex-row w-full gap-2">
                    <h5 class="flex text-left w-full text-lg">
                      {{ item.title | title }}
                    </h5>

                    <vs-dropdown
                      vs-trigger-click
                      class="w-fit h-fit cursor-pointer"
                    >
                      <div class="w-6 h-6 relative">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_735_19)">
                            <path
                              d="M12 17C12.5304 17 13.0391 17.2107 13.4142 17.5858C13.7893 17.9609 14 18.4696 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17ZM12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10ZM12 3C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5C14 5.53043 13.7893 6.03914 13.4142 6.41421C13.0391 6.78929 12.5304 7 12 7C11.4696 7 10.9609 6.78929 10.5858 6.41421C10.2107 6.03914 10 5.53043 10 5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3Z"
                              fill="#737171"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_735_19">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>

                      <vs-dropdown-menu class="ml-2 mt-2">
                        <div class="bg-white flex flex-col rounded">
                          <div
                            class="text-black flex-row items-center gap-2 hover:bg-slate-100 p-2 cursor-pointer"
                            @click="skipValidation(item)"
                          >
                            <!-- <span class="flex w-5 h-5 relative">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                class="object-cover flex h-full w-full"
                                fill="none"
                              >
                                <path
                                  d="M12.25 3.50073C12.7154 3.50059 13.1694 3.64478 13.5494 3.91342C13.9295 4.18206 14.2169 4.56195 14.372 5.00073C14.4406 5.18516 14.579 5.33522 14.7573 5.41856C14.9355 5.50191 15.1394 5.51185 15.3249 5.44624C15.5105 5.38064 15.6628 5.24475 15.749 5.06787C15.8353 4.891 15.8486 4.68731 15.786 4.50073C15.5274 3.76939 15.0485 3.1362 14.4152 2.68834C13.7818 2.24049 13.0252 2 12.2495 2C11.4738 2 10.7172 2.24049 10.0838 2.68834C9.45048 3.1362 8.97155 3.76939 8.713 4.50073C8.6467 4.68837 8.65765 4.89467 8.74345 5.07423C8.82924 5.2538 8.98286 5.39193 9.1705 5.45823C9.35814 5.52454 9.56444 5.51359 9.744 5.42779C9.92357 5.34199 10.0617 5.18837 10.128 5.00073C10.2833 4.56203 10.5707 4.18223 10.9507 3.9136C11.3307 3.64498 11.7846 3.50074 12.25 3.50073ZM21.5 6.75073C21.5 6.55182 21.421 6.36105 21.2803 6.2204C21.1397 6.07975 20.9489 6.00073 20.75 6.00073H3.75C3.55109 6.00073 3.36032 6.07975 3.21967 6.2204C3.07902 6.36105 3 6.55182 3 6.75073C3 6.94964 3.07902 7.14041 3.21967 7.28106C3.36032 7.42171 3.55109 7.50073 3.75 7.50073H20.75C20.9489 7.50073 21.1397 7.42171 21.2803 7.28106C21.421 7.14041 21.5 6.94964 21.5 6.75073ZM18.335 9.20073C18.3483 9.00222 18.4398 8.8171 18.5896 8.68611C18.7393 8.55511 18.935 8.48897 19.1335 8.50223C19.332 8.51549 19.5171 8.60707 19.6481 8.75682C19.7791 8.90657 19.8453 9.10222 19.832 9.30073L19.368 16.2527C19.283 17.5347 19.214 18.5707 19.052 19.3847C18.883 20.2297 18.597 20.9357 18.005 21.4887C17.414 22.0427 16.69 22.2817 15.835 22.3927C15.013 22.5007 13.975 22.5007 12.689 22.5007H11.81C10.525 22.5007 9.486 22.5007 8.664 22.3927C7.81 22.2817 7.086 22.0427 6.494 21.4887C5.903 20.9357 5.617 20.2287 5.448 19.3847C5.286 18.5707 5.218 17.5347 5.132 16.2527L4.668 9.30073C4.65474 9.10222 4.72088 8.90657 4.85188 8.75682C4.98287 8.60707 5.16799 8.51549 5.3665 8.50223C5.56502 8.48897 5.76067 8.55511 5.91041 8.68611C6.06016 8.8171 6.15174 9.00222 6.165 9.20073L6.625 16.1007C6.715 17.4477 6.779 18.3857 6.919 19.0907C7.056 19.7757 7.246 20.1377 7.519 20.3937C7.793 20.6497 8.167 20.8157 8.859 20.9057C9.572 20.9987 10.512 21.0007 11.863 21.0007H12.637C13.987 21.0007 14.927 20.9987 15.641 20.9057C16.333 20.8157 16.707 20.6497 16.981 20.3937C17.254 20.1377 17.444 19.7757 17.581 19.0907C17.721 18.3857 17.785 17.4477 17.875 16.1007L18.335 9.20073Z"
                                  fill="black"
                                />
                                <path
                                  d="M14.8253 11.0047C14.6274 10.9849 14.4298 11.0444 14.2759 11.1703C14.1219 11.2961 14.0242 11.4779 14.0043 11.6757L13.5043 16.6757C13.4896 16.8708 13.5518 17.0639 13.6775 17.2138C13.8032 17.3637 13.9825 17.4585 14.1771 17.4781C14.3718 17.4977 14.5664 17.4404 14.7194 17.3185C14.8724 17.1967 14.9718 17.0198 14.9963 16.8257L15.4963 11.8257C15.5161 11.6279 15.4565 11.4303 15.3307 11.2763C15.2049 11.1224 15.0231 11.0247 14.8253 11.0047ZM9.00426 11.8257C8.98961 11.6306 9.05177 11.4376 9.17748 11.2877C9.30318 11.1378 9.48248 11.0429 9.67713 11.0233C9.87178 11.0038 10.0664 11.061 10.2194 11.1829C10.3724 11.3048 10.4718 11.4816 10.4963 11.6757L10.9963 16.6757C11.0109 16.8708 10.9487 17.0639 10.823 17.2138C10.6973 17.3637 10.518 17.4585 10.3234 17.4781C10.1287 17.4977 9.93415 17.4404 9.78112 17.3185C9.62809 17.1967 9.52874 17.0198 9.50426 16.8257L9.00426 11.8257Z"
                                  fill="black"
                                />
                              </svg>
                            </span> -->
                            <p>Skip Validation</p>
                          </div>
                        </div>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                  <div class="w-full mt-0 flex items-center justify-between">
                    <div ref="itemOptions" class="flex items-center">
                      <div
                        class="flex items-center gap-4"
                        v-for="(token, i) in item.libraryItemValidationData
                          .tokens"
                        :key="i"
                      >
                        <!-- gold-coin -->
                        <div
                          v-if="token.label === 'Gold'"
                          class="flex items-end p-2 rounded-lg gap-1"
                          :id="
                            activeIndex === index
                              ? `${item.libraryItemValidationData.gtbrddOrganizationId.slice(
                                  -5
                                )}-reward-gold`
                              : ''
                          "
                        >
                          <img
                            class="w-8 h-8"
                            src="@/assets/images/icons/tokens/gold-coin.svg"
                            alt=""
                          />
                          <h6 class="text-base">
                            {{ token.value }}
                          </h6>
                        </div>

                        <!-- xp -->
                        <div
                          v-if="token.label === 'XPs'"
                          class="flex items-end p-2 rounded-lg gap-1"
                          :id="activeIndex === index ? 'reward-xp' : ''"
                        >
                          <img
                            class="w-8 h-8"
                            src="@/assets/images/icons/tokens/xp.svg"
                            alt=""
                          />

                          <h6 class="text-base">
                            {{ token.value }}
                          </h6>
                        </div>
                        <!-- knowledge token -->
                        <!-- <div
                        v-if="item.kt"
                        class="token-box flex items-center justify-center p-2 rounded-lg gap-1"
                      >
                        <img
                          class="w-8 h-8"
                          src="@/assets/images/icons/tokens/kt.svg"
                          alt=""
                        />
                        <h6 class="text-xl">{{ item.kt }}</h6>
                      </div> -->
                      </div>
                    </div>

                    <div>
                      <div
                        v-if="
                          item.reviewStatus &&
                          item.reviewStatus.toLowerCase() === 'accepted'
                        "
                        @click="claimReward(item, index)"
                        class="btn-claim text-xl font-medium rounded-lg py-2 px-4 cursor-pointer ml-2"
                      >
                        {{ item.tokenClaimed ? "Claimed" : "Claim" }}
                      </div>
                      <div
                        v-else-if="item.feedItemUserValidationStatus === false"
                        @click="validateItem(item)"
                        class="text-black ml-2 btn-validate text-lg font-semibold rounded-lg py-2 px-4 cursor-pointer"
                      >
                        Validate
                      </div>
                      <div v-else>
                        <vs-tooltip
                          text="Waiting for admin approval"
                          position="top"
                        >
                          <feather-icon
                            class="cursor-pointer"
                            style="color: #fb2e56"
                            icon="ClockIcon"
                            svgClasses="h-6 w-6"
                          />
                        </vs-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8"
            v-if="!loadingSkeleton && items.length === 0"
          >
            <img
              class="lg:w-4/12 w-64"
              src="@/assets/images/temp-img/empty-notification.svg"
            />
            <div class="flex flex-col gap-6 justify-center items-center">
              <p class="text-lg text-center font-semibold flex gap-2 flex-col">
                No Notification Found!
              </p>
            </div>
          </div>
        </div>

        <div
          v-if="
            notificationType === 'journey-quests' && appSubscriptions.journey
          "
          class="bg-white p-4 rounded-lg"
        >
          <div class="progress__container mt mb-4">
            <div class="progress__container__info">
              <img src="@/assets/images/icons/progress-coin.svg" />
              <span v-if="journeyIndex === 1"> {{ completedSteps * 100 }}</span>
              <span v-if="journeyIndex === 2">{{ completedSteps * 200 }}</span>
            </div>
            <div class="progress__container__bar">
              <vs-tooltip
                v-for="(step, i) in activeStep"
                :text="getStepName(step.id)"
                :key="i"
                class="flex justify-center"
                :class="i % 2 === 0 ? 'odd' : 'even'"
                :position="i % 2 === 0 ? 'top' : 'bottom'"
              >
                <a :href="step.url" target="_blank">
                  <img
                    :key="i"
                    :class="i % 2 === 0 ? 'odd' : 'even'"
                    :src="
                      require(`@/assets/images/icons/chest-${
                        i % 2 === 0 ? 'top' : 'bottom'
                      }.svg`)
                    "
                    :alt="step.id"
                  />
                </a>
              </vs-tooltip>

              <progress
                v-if="activeStep"
                class="progress"
                max="100"
                :value="getJourneyProgress(activeStep)"
              ></progress>
            </div>
          </div>
          <vs-row
            class="journey__notification__card cursor-pointer p-4 mb-3"
            v-for="(journeyQuest, i) in journeyQuests"
            :key="i"
            :class="`q${journeyIndex}` === i ? '' : 'opacity-50'"
          >
            <div class="w-full" @click="activeSelectedStep(journeyQuest, i)">
              <h4 class="flex text-white text-left font-semibold mb-4">
                Gala Quest {{ i === "q1" ? 1 : 2 }}
                <a
                  class="ml-3"
                  :href="journeyQuest.steps[1].url"
                  target="_blank"
                >
                  <img
                    src="@/assets/images/icons/arrow-right-circle-white.svg"
                    alt=""
                    class="w-6 h-6"
                  />
                </a>
              </h4>
              <progress
                class="progress w-full"
                max="100"
                :value="getJourneyProgress(journeyQuest.steps)"
              />

              <!-- <div class="flex items-start my-3">
                    <img src="@/assets/images/icons/clock.svg" alt="Clock" />
                    <h5 class="text-left ml-2 text-white">
                    Activated after Quest 1. Went live 4 Days 20 hours ago
                    </h5>
                </div> -->

              <div
                class="flex items-start mt-8 w-full items-center justify-between"
              >
                <h5 class="text-left text-white w-1/2">
                  Activated since <br />
                  <span class="font-semibold">
                    {{ getGoalActiveDate(i) }}
                    {{ i === "q1" ? questQ1 : questQ2 }}
                  </span>
                </h5>
                <div class="reward__container flex py-2 px-1">
                  <!-- gold-coin -->
                  <div
                    class="token-box flex items-center justify-center py-1 px-2 mx-1"
                  >
                    <img
                      class="w-6 h-6"
                      src="@/assets/images/icons/tokens/gold-coin.svg"
                      alt=""
                    />
                    <h6 class="ml-1 text-xl" v-if="i === 'q1'">500</h6>
                    <h6 class="ml-1 text-xl" v-if="i === 'q2'">500</h6>
                  </div>
                  <!-- xp -->
                  <div
                    class="token-box flex items-center justify-center p-2 mx-1"
                  >
                    <img
                      class="w-6 h-6"
                      src="@/assets/images/icons/tokens/xp.svg"
                      alt=""
                    />

                    <h6 class="ml-1 text-xl" v-if="i === 'q1'">5000</h6>
                    <h6 class="ml-1 text-xl" v-if="i === 'q2'">5000</h6>
                  </div>
                  <!-- key -->
                  <!-- <div
                        class="token-box flex items-center justify-center p-2 mx-1"
                    >
                        <img
                        class="w-6 h-6"
                        src="@/assets/images/icons/tokens/key.svg"
                        alt=""
                        />

                        <h6 class="ml-1 text-xl">5</h6>
                    </div> -->
                </div>
              </div>
            </div>
          </vs-row>
        </div>

        <div
          v-if="notificationType === 'growth-plans' && appSubscriptions.coach"
        >
          <vs-row
            v-if="
              coachUserData &&
              coachUserData.data &&
              Array.isArray(coachUserData.data) &&
              receivedCoachData
            "
          >
            <vs-table ref="table" v-model="selected" :data="coachUserData.data">
              <template slot="thead">
                <vs-th sort-key="id">{{ $t("coach.tblHeadings.th2") }}</vs-th>
                <vs-th class="flex justify-center" sort-key="name">{{
                  $t("coach.tblHeadings.th8")
                }}</vs-th>
                <vs-th sort-key="journey">{{
                  $t("coach.tblHeadings.th21")
                }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody v-if="data">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in coachUserData.data"
                  >
                    <vs-td>
                      <p class="product-name font-medium truncate">
                        {{ tr.userData[0].firstName }}
                      </p>
                    </vs-td>
                    <vs-td class="flex justify-center">
                      <feather-icon
                        v-if="tr.motivationSurvey === 1"
                        icon="CircleIcon"
                        :title="$t('coach.playerJourney.t3_1')"
                        :svgClasses="['fill-current h-4 w-4', 'text-primary']"
                      />
                      <feather-icon
                        v-else-if="tr.motivationSurvey === 2"
                        icon="CircleIcon"
                        :title="$t('coach.playerJourney.t3_2')"
                        :svgClasses="[
                          'fill-current nt h-4 w-4',
                          'text-warning',
                        ]"
                      />
                      <feather-icon
                        v-else
                        icon="CircleIcon"
                        :title="$t('coach.playerJourney.t3_3')"
                        :svgClasses="['fill-current h-4 w-4', 'text-grey']"
                      />
                      <feather-icon
                        v-if="tr.coachingSurvey === 1"
                        class="ml-2"
                        icon="CircleIcon"
                        :title="$t('coach.playerJourney.t4_1')"
                        :svgClasses="['fill-current h-4 w-4', 'text-primary']"
                      />
                      <feather-icon
                        v-else-if="tr.coachingSurvey === 2"
                        class="ml-2"
                        icon="CircleIcon"
                        :title="$t('coach.playerJourney.t4_2')"
                        :svgClasses="['fill-current h-4 w-4', 'text-warning']"
                      />
                      <feather-icon
                        v-else
                        class="ml-2"
                        icon="CircleIcon"
                        :title="$t('coach.playerJourney.t4_3')"
                        :svgClasses="['fill-current h-4 w-4', 'text-grey']"
                      />
                    </vs-td>

                    <vs-td>
                      <vs-tooltip
                        text="Development"
                        position="bottom"
                        class="flex justify-center"
                      >
                        <feather-icon
                          @click="toCoach"
                          class="p-1 rounded-md add-btn cursor-pointer text-center w-8 h-8"
                          icon="ArrowRightIcon"
                        />
                      </vs-tooltip>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </vs-row>

          <vs-row v-else-if="growthPlan.complete && growthPlan.inProgress">
            <vs-row v-if="growthPlan.inProgress.length > 0">
              <h4 class="mb-2 font-semibold text-xl text-black">In Progress</h4>
              <vs-col
                class="mb-3"
                v-for="plan in growthPlan.inProgress"
                :key="plan.id"
              >
                <div
                  v-if="getCompentencyData(plan.competencyId)"
                  class="w-full flex items-center"
                >
                  <vs-avatar
                    class=""
                    size="40px"
                    :src="getCompentencyData(plan.competencyId).icon"
                  />
                  <h4>{{ getCompentencyData(plan.competencyId).comp }}</h4>
                </div>
              </vs-col>
            </vs-row>

            <vs-row v-if="growthPlan.complete.length > 0">
              <h4 class="mb-2 font-semibold text-xl text-black">In Progress</h4>
              <vs-col
                class="mb-3"
                v-for="plan in growthPlan.complete"
                :key="plan.id"
              >
                <div
                  v-if="getCompentencyData(plan.competencyId)"
                  class="w-full flex items-center"
                >
                  <vs-avatar
                    class=""
                    size="40px"
                    :src="getCompentencyData(plan.competencyId).icon"
                  />
                  <h4>{{ getCompentencyData(plan.competencyId).comp }}</h4>
                </div>
              </vs-col>
            </vs-row>
          </vs-row>

          <vs-row 
          v-else-if="receivedCoachData"
          >
            <vs-col class="flex flex-col items-center">
              <img
                class="lg:w-3/12 w-64"
                src="@/assets/images/temp-img/empty-growth-plan.svg"
                alt="no quest"
              />
              <h5 class="my-4">No development plans active !</h5>
            </vs-col>
          </vs-row>
        </div>

        <div
          class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8"
          v-else-if="
            !appSubscriptions.coach &&
            !appSubscriptions.alex &&
            !appSubscriptions.journey
          "
        >
          <img
            class="lg:w-3/12 w-64"
            src="@/assets/images/temp-img/empty-notification.svg"
          />
          <div class="flex flex-col gap-6 justify-center items-center">
            <p
              class="text-xl text-center flex gap-2 flex-col font-semibold text-black"
            >
              No notifications found!

              <br />

              <span class="font-normal text-slate-600 text-base"
                >Assign yourself tasks through your organization.</span
              >
            </p>
            <router-link
              to="/user/my-organizations"
              class="py-2 px-4 bg-primary text-slate-950 w-fit text-lg rounded-lg font-semibold"
              >Go to Organizations</router-link
            >
          </div>
        </div>
      </div>

      <div
        @click="claimAllRewards()"
        v-if="
          notificationType === 'learning-actions' &&
          !loadingSkeleton &&
          claimAllBtn &&
          items &&
          items.length > 0
        "
        class="sticky bottom-0 claim-all-btn p-4 flex justify-end"
      >
        <div
          class="max-w-max btn-claim-all text-lg font-medium rounded-lg py-2 px-4 cursor-pointer"
        >
          Read and Claim All
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import appSteps from "@/assets/data/app-flow";
import { setTimezone } from "@amcharts/amcharts4/.internal/core/utils/Time";

import gsap from "gsap";

export default {
  data() {
    return {
      notificationType: "",
      mergedItems: [],
      items: [],
      loadingSkeleton: true,
      coachUserData: {},
      growthPlan: [],
      selected: [],
      fill: { gradient: ["#4D927F", "#B7DA64"] },
      receivedCoachData: false,
      claimAllBtn: false,
      CCD: this.$t("coach.addNewSkill.data"),
      learningActionItems: false,
      activeIndex: null,
      journeyQuests: {},
      activeStep: {},
      completedSteps: 0,
      journeyIndex: 1,
      galaQuests: false,
      questQ1: "",
      questQ2: "",
      appSteps,
    };
  },
  components: {
    VuePerfectScrollbar,
  },
  computed: {
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userData() {
      return this.$store.state.users.data;
    },
    userOrganization() {
      return this.$store.state.users.selectedOrganization;
    },
    notificationPanelPopup() {
      return this.$store.state.modals.notificationPanelPopup;
    },
    appSubscriptions() {
      return this.$store.state.users.appSubscriptions;
    },
    journeySteps() {
      return appSteps.flow.journey.steps;
    },
  },
  watch: {
    notificationType: {
      immediate: true,
      handler(newVal) {
        this.loadingSkeleton = true;
        if (newVal === "learning-actions") {
          this.fetchUserInterestedItems();
        } else if (newVal === "journey-quests") {
          this.getJourneyQuests();
        } else if (newVal === "growth-plans") {
          this.fetchGrowthPlans();
        }
      },
    },
    items: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          let claimItems = [];
          for (let i = 0; i < newVal.length; i++) {
            if (
              (newVal[i].reviewStatus && !newVal[i].tokenClaimed) ||
              (newVal[i].libraryItemValidationData &&
                (newVal[i].status === "done" ||
                  newVal[i].feedLibraryItemStatus === "done"))
            ) {
              this.learningActionItems = true;
            }

            if (
              ((newVal[i].reviewStatus &&
                newVal[i].reviewStatus.toLowerCase() === "accepted") ||
                newVal[i].feedItemUserValidationStatus) &&
              !newVal[i].tokenClaimed
            ) {
              claimItems.push(newVal[i]);
            }
            this.claimAllBtn = claimItems.length > 0 ? true : false;
          }
        }
      },
    },
    notificationPanelPopup: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.notificationType === "learning-actions") {
            this.fetchUserInterestedItems();
          }
        }
      },
    },
    userOrganizations: {
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          this.galaQuests =
            newVal[i].organizationData.slug === "gala" ? true : false;
        }
      },
      deep: true,
      immediate: true,
    },
    appSubscriptions: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal.alex) {
          this.notificationType = "learning-actions";
        }
        // else if (newVal.journey) {
        //   this.notificationType = "journey-quests";
        //   this.getJourneyQuests();
        // }
        else if (newVal.coach) {
          this.notificationType = "growth-plans";
        } else {
          return (this.loadingSkeleton = false);
        }
      },
    },
  },
  mounted() {
    if (this.appSubscriptions && this.appSubscriptions.alex) {
      this.notificationType = "learning-actions";
    } else if (this.appSubscriptions && this.appSubscriptions.coach) {
      this.notificationType = "growth-plans";
    }
  },
  methods: {
    mergeArrays(array1, array2) {
      const merged = [];
      const idSet = new Set();
      if (array1.length > 0) {
        for (const item of array1) {
          merged.push(item);
          idSet.add(item.feedItemId);
        }
      }

      if (array2.length > 0) {
        for (const item of array2) {
          if (idSet.has(item.itemId)) {
            const existingItem = merged.find(
              (el) => el.feedItemId === item.itemId
            );
            Object.assign(existingItem, item);
          } else {
            merged.push(item);
            idSet.add(item.itemId);
          }
        }
      }

      for (let i = 0; i < merged.length; i++) {
        if (
          merged[i].libraryItemValidationData &&
          (merged[i].status === "done" ||
            merged[i].feedLibraryItemStatus === "done")
        ) {
          this.mergedItems.push(merged[i]);
        }
      }
    },
    fetchUserInterestedItems() {
      if (this.notificationType === "learning-actions") {
        this.items = [];
        this.mergedItems = [];
        this.loadingSkeleton = true;
        this.$store
          .dispatch("alex/getRedirectItemsCount", {
            gtbrddUserId: this.$store.state.auth.user._id,
            source: ["LIBRARY"],
          })
          .then((res) => {
            if (res && res.data && res.data.length > 0) {
              let itemIds = [];
              let array1 = res.data;
              for (let element of res.data) {
                if (
                  element.libraryItemValidationData &&
                  element.feedItemId !== null
                ) {
                  if (!itemIds.includes(element.feedItemId)) {
                    itemIds.push(element.feedItemId);
                  }
                }
              }

              this.$store
                .dispatch("feed/fetchBulkItemDetails", {
                  itemId: itemIds,
                  getboardedId: this.$store.state.auth.user._id,
                })
                .then((res) => {
                  let array2 = [];
                  if (res && res.length > 0 && typeof res !== "string") {
                    array2 = res;
                    this.mergeArrays(array1, array2);
                    this.items = this.mergedItems;
                  } else {
                    this.mergeArrays(array1, array2);
                    this.items = this.mergedItems;
                  }
                })
                .catch((err) => {
                  this.mergeArrays(array1, []);
                  this.items = this.mergedItems;
                });

              if (res.data.length > 0) {
                this.loadingSkeleton = true;
                let fetchCustomLibraryItemPromises = [];

                for (let a = 0; a < res.data.length; a++) {
                  if (
                    res &&
                    res.data &&
                    res.data[a] &&
                    res.data[a].feedItemId &&
                    res.data[a].feedItemId.includes("altf")
                  ) {
                    const payload = {
                      orgId: "6512fc951aa789001abd5ed4",
                      itemId: res.data[a].feedItemId,
                      userId: this.$store.state.auth.user._id,
                    };
                    let item = res.data[a];
                    let promise = this.$store
                      .dispatch("alex/fetchCustomLibraryItem", payload)
                      .then((res) => {
                        if (
                          res.data &&
                          item.libraryItemValidationData &&
                          (res.data.status === "done" ||
                            res.data.feedLibraryItemStatus === "done")
                        ) {
                          this.items.push({ ...res.data, ...item });
                        }
                      })
                      .catch((err) => {
                        // Handle error
                      });
                    fetchCustomLibraryItemPromises.push(promise);
                  }
                }

                Promise.all(fetchCustomLibraryItemPromises)
                  .then(() => {
                    this.loadingSkeleton = false;
                  })
                  .catch((err) => {});
              } else {
                this.loadingSkeleton = false;
              }
            }
          })
          .catch((err) => {
            this.loadingSkeleton = false;
          });
      }
    },
    randomFeedImage(e) {
      let i = 15; // i = number of given random images
      return (e.target.src = require(`@/assets/images/user-dashboard/blank-feed/${[
        Math.floor(Math.random() * i),
      ]}.png`));
    },
    openLink(item) {
      let link = `https://library.getboarded.com/redirect-page?itemId=${
        item.itemId
      }&type=${item.type || item.itemType}&gbuid=${this.userData._id}&gborgid=${
        this.userOrganization.organizationId
      }&redirectsourceid=USER_DASHBOARD`;
      if (link && !this.queries && !this.disableLink) {
        window.open(link, "_blank");
      }
    },
    validateItem(item) {
      event.stopPropagation();
      let itemData = [
        {
          id: item.itemId,
          slug: this.userOrganization.organizationData.slug,
          vType: item.libraryItemValidationData.validationType,
          token: this.$store.state.auth.accessToken,
          orgId: item.libraryItemValidationData.gtbrddOrganizationId,
        },
      ];
      this.$parent.itemData = itemData;
      this.$parent.activeAlex = true;
      // this.$store.commit("modals/OPEN_CHAT_BOT_POPUP", true);
      // this.$store.commit("users/SET_VALIDATE_ITEM", true);
      // this.$store.commit("users/SET_ITEM_TO_VALIDATE", item);
      // this.$store.commit("modals/OPEN_NOTIFICATION_POPUP", false);
    },
    fetchGrowthPlans() {
      // this.loadingSkeleton = true;
      this.receivedCoachData = false;
      for (let i = 0; i < this.userOrganizations.length; i++) {
        this.$store
          .dispatch("users/getGrowthPlans", {
            userId: this.userData._id,
            orgId: this.userOrganizations[i].organizationId,
          })
          .then((res) => {
            if (res && res.data) {
              this.growthPlan = res.data;
            }
            if (res.code === "USER_IS_COACH") {
              return this.getCoachUserData();
            }
          })
          .catch((err) => {})
          .finally(() => {
            this.receivedCoachData = true;
            this.loadingSkeleton = false;
          });
      }
    },
    getJourneyQuests() {
      this.loadingSkeleton = true;
      this.$store
        .dispatch("users/fetchJourneyQuests", {
          gtbrddUserId: this.userData._id,
        })
        .then((res) => {
          this.journeyQuests = res.data;
          for (let key in res.data) {
            this.activeSelectedStep(res.data[key], key);
            break;
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loadingSkeleton = false;
        });
    },
    getCoachUserData() {
      this.$store
        .dispatch("coach/getCoachUserData", this.userData._id)
        .then((res) => {
          this.coachUserData = res;
        })
        .catch((err) => {})
        .finally(() => {
          this.receivedCoachData = true;

          setTimeout(() => {
            this.loadingSkeleton = false;
          }, 1000);
        });
    },
    toCoach() {
      let user = this.userData.email.slice(0, this.userData.email.indexOf("@"));
      window.location.href = `https://api.coach.getboarded.com/oauth/?selectedAccount=${user}`;
    },
    claimReward(item, index) {
      event.stopPropagation();

      // this.activeIndex = index;
      // setTimeout(() => {
      //   const ipGold = document
      //     .getElementById(
      //       `${item.libraryItemValidationData.gtbrddOrganizationId.slice(
      //         -5
      //       )}-reward-gold`
      //     )
      //     .getBoundingClientRect();

      //   this.$store.commit("animation/SET_INITIAL_POSITION_FOR_GOLD", {
      //     top: ipGold.top,
      //     bottom: ipGold.bottom,
      //     left: ipGold.left,
      //     right: ipGold.right,
      //   });

      //   const ipXp = document
      //     .getElementById("reward-xp")
      //     .getBoundingClientRect();

      //   this.$store.commit("animation/SET_INITIAL_POSITION_FOR_XP", {
      //     top: ipXp.top,
      //     bottom: ipXp.bottom,
      //     left: ipXp.left,
      //     right: ipXp.right,
      //   });
      //   this.$store.commit(
      //     "animation/SET_GOLD_ID",
      //     item.libraryItemValidationData.gtbrddOrganizationId.slice(-5)
      //   );
      //   this.$store.commit("animation/SET_ANIMATION_STATUS", true);
      // }, 50);

      if (!item.tokenClaimed) {
        const payload = {
          gtbrddOrganizationId:
            item.libraryItemValidationData.gtbrddOrganizationId,
          gtbrddUserId: this.userData._id,
          libraryItemId: item.itemId,
        };
        this.$store
          .dispatch("alex/claimRewards", payload)
          .then((res) => {
            if (res && res.data && res.data._id) {
              for (let i = 0; i < this.items.length; i++) {
                let itemsClaimedCount = 0;
                let itemsToBeClaimedCount = 0;
                if (this.items[i].tokenClaimed) {
                  itemsClaimedCount = itemsClaimedCount + 1;
                }

                if (this.items[i].reviewStatus) {
                  itemsToBeClaimedCount = itemsToBeClaimedCount + 1;
                }

                if (itemsClaimedCount === itemsToBeClaimedCount) {
                  this.claimAllBtn = false;
                }
              }

              this.activeIndex = index;

              setTimeout(() => {
                const ipGold = document
                  .getElementById(
                    `${item.libraryItemValidationData.gtbrddOrganizationId.slice(
                      -5
                    )}-reward-gold`
                  )
                  .getBoundingClientRect();

                this.$store.commit("animation/SET_INITIAL_POSITION_FOR_GOLD", {
                  top: ipGold.top,
                  bottom: ipGold.bottom,
                  left: ipGold.left,
                  right: ipGold.right,
                });

                const ipXp = document
                  .getElementById("reward-xp")
                  .getBoundingClientRect();

                this.$store.commit("animation/SET_INITIAL_POSITION_FOR_XP", {
                  top: ipXp.top,
                  bottom: ipXp.bottom,
                  left: ipXp.left,
                  right: ipXp.right,
                });
                this.$store.commit(
                  "animation/SET_GOLD_ID",
                  item.libraryItemValidationData.gtbrddOrganizationId.slice(-5)
                );
                this.$store.commit("animation/SET_ANIMATION_STATUS", true);
              }, 50);

              item.libraryItemValidationData.tokens.forEach((tokenObj) => {
                tokenObj["organizationId"] =
                  item.libraryItemValidationData.gtbrddOrganizationId;
              });
              this.$store.commit(
                "users/UPDATE_USER_TOKENS",
                item.libraryItemValidationData.tokens
              );
              this.items[index].tokenClaimed = true;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    claimAllRewards() {
      for (let i = 0; i < this.items.length; i++) {
        if (
          this.items[i].reviewStatus ||
          this.items[i].feedItemUserValidationStatus
        ) {
          this.claimReward(this.items[i], i);
        }
      }
    },
    getCompentencyData(id) {
      const characteristicId = id.split("-")[0];
      const competencyId = id.split("-")[1];
      const competencies = this.CCD[characteristicId].competencies;
      return competencies[competencyId];
    },
    getTokenValue(tokens, key) {
      if (tokens) {
        let token = tokens.find((token) => token.key === key);
        return token ? token.value : 0;
      }
    },
    getJourneyProgress(steps) {
      let totalSteps = steps.length;
      let completedSteps = 0;
      for (let i = 0; i < steps.length; i++) {
        if (steps[i].completionPercentage === 100) {
          completedSteps = completedSteps + 1;
        }
      }
      return (100 * completedSteps) / totalSteps;
    },
    activeSelectedStep(journeyQuest, i) {
      this.activeStep = journeyQuest.steps;
      let completedSteps = 0;
      for (let i = 0; i < this.activeStep.length; i++) {
        if (this.activeStep[i].completionPercentage === 100) {
          completedSteps = completedSteps + 1;
        }
      }
      this.completedSteps = completedSteps;
      this.journeyIndex = i === "q1" ? 1 : 2;
    },
    getGoalActiveDate(quest) {
      let boardId =
        quest === "q1"
          ? "63f7ac7c99ee08001de8c9b0"
          : "64f48a69c433ae00195dbeb0";
      this.$store
        .dispatch("boards/fetchCurrentBoardUserDetails", {
          userId: this.userData._id,
          boardId: boardId,
        })
        .then((res) => {
          if (res && res.data && res.data[0] && res.data[0].createdAt) {
            const timestamp = new Date(res.data[0].createdAt);
            const day = timestamp.getDate();
            const monthNames = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ];
            const month = monthNames[timestamp.getMonth()];
            const year = timestamp.getFullYear();
            const formattedDate = `${day} ${month} ${year}`;
            if (quest === "q1") {
              this.questQ1 = formattedDate;
            } else if (quest === "q2") {
              this.questQ2 = formattedDate;
            }
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    // getStepName(step) {
    //   console.log("jj", step, this.journeySteps);
    //   let stepName = this.journeySteps.find((step) => {
    //     console.log(step, step.id);
    //     step.id === step;
    //   });
    //   console.log("eeee", stepName ? stepName.title : step);
    // },
    getStepName(stepId) {
      let step = this.journeySteps.find((step) => step.id === stepId);
      return step ? step.title : stepId;
    },
    skipValidation(item) {
      const payload = {
        gtbrddUserId: this.userData._id,
        gtbrddOrganizationId:
          item.libraryItemValidationData.gtbrddOrganizationId,
        feedItemId: item.itemId,
      };

      this.$store
        .dispatch("alex/skipItemValidation", payload)
        .then((res) => {
          if (res && res.data && res.data._id) {
            this.$refs.itemOptions[0].click();

            this.$vs.notify({
              title: "Validation skipped successfully !",
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success",
            });

            const tl = gsap.timeline({
              defaults: {
                duration: 0.5,
                ease: "rough",
                repeat: 0,
              },
            });
            tl.fromTo(
              "#" + item.itemId,
              0.5,
              { opacity: 1, display: "flex" },
              { opacity: 0, display: "flex" }
            );

            tl.fromTo(
              "#" + item.itemId,
              0.5,
              { opacity: 0, display: "none" },
              { opacity: 0, display: "none" }
            );
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  &__container {
    z-index: 10;

    .notification-header {
      position: sticky;
      top: 0rem;
      z-index: 10;
      background: #fff;

      .types {
        margin: 0 -1em;
      }
    }

    .token-box {
      border-radius: 0.5rem;
      // background: #fff;
      background: #f2f4f7;
      border: 1px solid #d0d5dd;

      // box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25) inset,
      //   0px 4px 10px 0px rgba(0, 0, 0, 0.1);

      h6 {
        color: #676767 !important;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        font-weight: 500;
        right: 0;
        bottom: -10px;
      }
    }

    .btn {
      &-claim {
        background: #25cc9a1a;
        color: #25cc9a;

        &-all {
          background: #f2f4f7;
          color: #98a2b3;
        }
      }

      &-validate {
        background: #f8c62c;
        color: #fff;
      }
    }

    .claim-all-btn {
      background: #fff;
    }

    .heading {
      &-gray {
        color: #808080 !important;
      }
    }

    .border {
      border: 2px solid #efefef;
    }
  }

  &__inactive {
    h4 {
      color: #5e5b5b !important;
      font-weight: 400;
    }
  }

  &__active {
    h4 {
      color: #101828 !important;
      font-weight: 600;
    }
  }
}

.journey__notification__card {
  border-radius: 0.75rem;
  background: #7a5af8;

  .reward__container {
    border-radius: 0.375rem;
    background: rgba(255, 255, 255, 0.5);
  }

  .progress {
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 10px;
    border: 2px solid #fff;
    height: 15px;
    background-color: #fff;
    text-align: left;
  }

  /* For Chrome or Safari */
  progress::-webkit-progress-bar {
    background-color: #ffffff;
    border-radius: 10px;
  }

  progress::-webkit-progress-value {
    background-color: #25cc9a !important;
    border-radius: 10px;
    place-self: start;
  }

  /* For Firefox */

  progress::-moz-progress-bar {
    background-color: #25cc9a !important;
    border-radius: 10px;
  }
}

$bg: #fba62742;
$color: #fba727;

.icon-bg {
  background-color: $bg;
}

.skills-btn {
  color: $color !important;
  background: $bg;
}

.vx-card ::v-deep .vx-card__body {
  padding: 0;
}

.opacity {
  opacity: 0.075;
}

.webkit-width {
  width: -webkit-fill-available;
}

.circle ::v-deep .percent-text {
  font-size: 15px !important;
}

.stick-top {
  top: 6em;
}

.vs-con-table ::v-deep .vs-table--tbody-table {
  min-width: 100%;
}

.vs-con-table {
  width: 100%;
}

.add-btn {
  color: #fff;
  background: $color;
  border-radius: 5em;
}

.skeleton {
  background: #808080;
  animation: flicker-light 1s infinite alternate;
}

@keyframes flicker-light {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.2;
  }
}

@media screen and (max-width: 991px) {
  .vs-con-table ::v-deep .vs-table--content {
    width: 100%;
  }
}

.ps ::v-deep .ps__scrollbar-y-rail {
  z-index: 100;
}

.progress__container {
  background-color: rgba(255, 215, 97, 0.3);
  width: 100%;
  min-height: 15rem;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  gap: 2rem;
  align-items: center;
  text-align: left;

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 1.5rem;
    position: relative;

    img {
      width: 3rem;
      height: auto;
    }

    span {
      color: #ffb70c;
      // font-family: Poppins;
      font-size: 1rem;
      font-weight: 600;
      height: fit-content;
      position: absolute;
      margin-top: 5.5rem;
    }
  }

  &__bar {
    width: 100%;
    margin-right: 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    height: 10rem;
    position: relative;

    img {
      width: 2rem;
      place-self: start;
    }

    .odd {
      place-self: start;
    }

    .even {
      place-self: end;
    }

    .progress {
      width: 100%;
      -webkit-appearance: none;
      appearance: none;
      border: none;
      border-radius: 10px;
      height: 15px;
      background-color: #fcde98;
      place-self: center;
      position: absolute;
      text-align: left;
    }

    /* For Chrome or Safari */
    progress::-webkit-progress-bar {
      background-color: #fcde98;
      border-radius: 10px;
    }

    progress::-webkit-progress-value {
      background-color: #25cc9a !important;
      border-radius: 10px;
    }

    /* For Firefox */

    progress::-moz-progress-bar {
      background-color: #25cc9a !important;
      border-radius: 10px;
    }
  }
}

@media screen and (max-width: 530px) {
  .notification {
    &__container {
      left: 0;
      width: 100%;
    }
  }
}
</style>
